import "@mui/lab/themeAugmentation";
import { useSelector } from "react-redux";
import { createTheme as createMuiTheme } from "@mui/material/styles";

import variants from "./variants";
import typography from "./typography";
import breakpoints from "./breakpoints";
import components from "./components";

const useCreateTheme = (name) => {
  let themeConfig = variants.find((variant) => variant.name === name);

  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`));
    themeConfig = variants[0];
  }

  const { siteColors } = useSelector((state) => state.renderUIDetails);

  components = {
    ...components,

    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
          color: "#fff",
          backgroundColor: siteColors.primary,
          "&:hover": {
            backgroundColor: siteColors.primary,
          },
        },
        outlined: {
          boxShadow: "none",
          color: siteColors.primary,
          borderColor: siteColors.primary,
          "&:hover": {
            borderColor: siteColors.primary,
          },
        },
      },
    },
  };

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints: breakpoints,
      // @ts-ignore
      components: components,
      typography: typography,
      palette: themeConfig.palette,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    }
  );
};

export default useCreateTheme;
